import React, { useEffect, useMemo, useState } from "react";
import "./FilmProjectorSection.css";
import api from "../../api";
import bgImg from "../../assets/immortalbg.avif";
import OldCamera from "../../assets/oldcamera3d.avif";
import { useNavigate } from "react-router-dom";

export default function FilmProjectorSection({
  background = bgImg,
  intervalMs = 10000,
  title = "MEMORIES ARE NOT JUST ABOUT THE PAST.",
  subtitle = "THEY DETERMINE OUR FUTURE.",
}) {
  const [index, setIndex] = useState(0);
  const [fadeKey, setFadeKey] = useState(0);
  const [immortalData, setImmortalData] = useState([]);
  const safeSlides = useMemo(() => (immortalData?.length ? immortalData : []), [immortalData]);
  const navigate = useNavigate();
  useEffect(() => {
    if (safeSlides.length <= 1) return;

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % safeSlides.length);
      setFadeKey((k) => k + 1);
    }, intervalMs);

    return () => clearInterval(id);
  }, [safeSlides.length, intervalMs]);

  // const current = safeSlides[index] || "";
  // ✅ get current image URL
  const current = safeSlides[index]?.img
    ? `http://api.righttracklb.com/assets/${safeSlides[index].img}`
    : "";

  const currentSlide = safeSlides[index];

  const goToSlidePage = () => {
    if (!currentSlide?.product_id) return;
    navigate(`/products/${currentSlide.product_id}`);
  };
  const fetchImmortalData = async () => {
    try {
      const res = await api.get("immortal/show");
      setImmortalData(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchImmortalData();
  }, []);

  useEffect(() => {
    function updateCameraPosition() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const scaleW = Math.min(w, 1920) / 1920; // ✅ cap at 1920
      const scaleH = Math.min(h, 1080) / 1080; // optional cap

      const isShortScreen = h < 800;
      const base = isShortScreen ? -340 : -180;

      const bottom = base * scaleH;
      const left = -4 * scaleW;

      document.documentElement.style.setProperty("--cam-bottom", bottom + "px");
      document.documentElement.style.setProperty("--cam-left", left + "%");
      // const refH = 1080;
      // const refW = 1920;
      // const isShortScreen = h < 800;   
      // const base = isShortScreen ? -340 : -180;
      // const bottom = base * (h / refH);
      // const left = -4 * (w / refW);
      // document.documentElement.style.setProperty("--cam-bottom", bottom + "px");
      // document.documentElement.style.setProperty("--cam-bottom", "-235px");
      // document.documentElement.style.setProperty("--cam-left", left + "%");
    }

    updateCameraPosition();
    window.addEventListener("resize", updateCameraPosition);
    return () => window.removeEventListener("resize", updateCameraPosition);
  }, []);

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % safeSlides.length);
    setFadeKey((k) => k + 1);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + safeSlides.length) % safeSlides.length);
    setFadeKey((k) => k + 1);
  };


  return (
    <section className="fps" style={{ "--bg": `url(${background})` }}>
      <div className="fps__overlay" />

      <img src={OldCamera} alt="Old camera" className="old-camera" />
      <div className="camera-light-beam" />
      <div className="fps__content">
        <div className="fps__left">
          {/* <div className="fps__quote">
            <div className="fps__quoteLine">{title}</div>
            <div className="fps__quoteLine">{subtitle}</div>
          </div> */}
        </div>

        <div className="fps__right">
          <div className="fps__screenWrap">
            <div className="fps__screenFrame">
              {/* <div className="fps__projection" key={fadeKey}> */}
              <div
                className="fps__projection"
                key={fadeKey}
                role="link"
                tabIndex={0}
                onClick={goToSlidePage}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    goToSlidePage();
                  }
                }}
                aria-label="Open slide details"
                title="Open details"
              >
                {/* image */}
                <img className="fps__img" src={current} alt="film slide" />

                {/* overlays ON TOP of the image */}
                <div className="fps__tubeGlow" />
                <div className="fps__vignette" />
                <div className="fps__scanlines" />
                <div className="fps__dust" />
                <div className="fps__flicker" />
                <div className="fps__lightSweep" />
                <div className="fps__grain" />
              </div>
              <div className="fps__quote">
                <div className="fps__quoteLine">{title}</div>
                <div className="fps__quoteLine">{subtitle}</div>
              </div>
            </div>

            <div className="fps__spill" />
            <button
              className="fps__prevBtn"
              onClick={handlePrev}
              aria-label="Previous Slide"
            >
              &#10094; {/* left arrow */}
            </button>
            <button
              className="fps__nextBtn"
              onClick={handleNext}
              aria-label="Next Slide"
            >
              &#10095; {/* right arrow */}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
